// Packages
import PropTypes from 'prop-types';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import dayjs from 'dayjs';

// Components
import BTDSkeleton from 'components/BTDUI/BTDSkeleton';
import Currency from 'components/BTDUI/Currency';

// Other
import './styles.css'

const ExpiredBookingListItem = ({ contact_name, created_at, expiry_date, id, isLoading, total, trading_name, }) => {

	dayjs.extend(advancedFormat);

	return (
		<>
		<div className="ExpiredBookingListItem">

			<div className='ExpiredBookingListItem__date'>
				<p className='blue'>{! isLoading ? '#' + id : <BTDSkeleton />}</p>
				<p className='blue opacity'>{! isLoading ? dayjs(created_at).format('D MMM YYYY') : ''}</p>
			</div>

			<p className='blue'><span className='ExpiredBookingListItem__label semi-bold'>Name: </span>{! isLoading ? contact_name : <BTDSkeleton />}</p>
			<p className='blue'><span className='ExpiredBookingListItem__label semi-bold'>Organisation: </span>{! isLoading ? trading_name : <BTDSkeleton />}</p>
			<p className='blue right'>{! isLoading ? <Currency value={total} /> : <BTDSkeleton />}</p>
			<p className='red centre'>{! isLoading ? dayjs(expiry_date).format('D MMM YYYY') : <BTDSkeleton />}</p>

		</div>

		</>
	)
}

ExpiredBookingListItem.propTypes = {
	contact_name: PropTypes.string,
	created_at: PropTypes.string,
	expiry_date: PropTypes.string,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	isLoading: PropTypes.bool,
	total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	trading_name: PropTypes.string,
	onChange: PropTypes.func,
}

ExpiredBookingListItem.defaultProps = {
	contact_name: null,
	created_at: null,
	expiry_date: null,
	id: null,
	isLoading: false,
	total: null,
	trading_name: null,
	onChange: () => {'onChange is not set!'},
}

export default ExpiredBookingListItem;